import { Dashboard } from "../components/dashboard/dashboard";
import { lazyRetry } from "../lib/lazy-retry";
import { sectionPreloader } from "../lib/section-preload";

const VisaMapBody = lazyRetry(() => import("./visa-proto/map").then((m) => ({ default: m.VisaMapBody })));
sectionPreloader.register("visa", VisaMapBody.preload);

export function HomePage() {
  // Section 3.3 (Visa & entry) renders the openness-map body — the same one the
  // /visa-map design prototype used — promoted to the live dashboard via the
  // sectionOverrides hook so it shows when you click "3.3 Visa & entry".
  return <Dashboard sectionOverrides={{ visa: <VisaMapBody /> }} />;
}
